export default __webpack_public_path__ + "d692f3dcd5f906b35a8e803ad93bbe0e.otf";